export default "__VITE_ASSET__CG9Sjqfl__"